module.exports = __webpack_public_path__ + "media/images/webpage/hotels/93/plan1-3-80466bcdeff48d23c6dc21b5e3f845d0.webp";